module.exports = function lazyLoadCaptcha() {
  const captchaScriptTag = cube.$$('.getCaptchaScript');

  captchaScriptTag.forEach(captcha => {
    if (captcha && !captcha.src)
      captcha.src = captcha.dataset.src;
  });
};



// WEBPACK FOOTER //
// ./src/modules-es5/commons/lib/lib-lazy-captcha.js